import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators, NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { DataShareService } from '../shared/data-share.service';
import { OrderDetails } from '../shared/model/order-details.model';

@Component({
    selector: 'creditcard-payment-decline',
    templateUrl: './creditcard-payment-decline.component.html'
  })
export class CreditCardPaymentDeclineComponent implements OnInit {
    
    hostedPaymentToken: string;
    orderDetails: OrderDetails = new OrderDetails();
    paramSubscribe: any;

    constructor(private dataShareService: DataShareService,
        private activatedRoute: ActivatedRoute, 
        private router: Router) { }
        
    ngOnInit() {
        this.dataShareService.data.subscribe(
            (data) => {
                this.orderDetails = data.get('order');
                this.hostedPaymentToken = data.get('hostedPaymentToken');
            }
        );
    }

    onRetry() {
        this.router.navigate(['/hosted/card/payment', this.hostedPaymentToken]);
    }

    onCancel() {
        window.location.href = this.orderDetails.onCancelUri;
    }
    
}